import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import classnames from "classnames";

import PrivateRoute from "./PrivateRoute/PrivateRoute";

import ConfirmationPage from "../confirmationPage/components/ConfirmationPage";
import ForgotPasswordContainer from "../ForgotPassword/containers/ForgotPasswordContainer";
import CommonLogInContainer from "../../common/logIn/containers/LogInContainer";
import ResetPasswordContainer from "../resetPassword/containers/ResetPasswordContainer";

import AdminCompanyBillingAddContainer from "../../admin/company/containers/AdminCompanyBillingAddContainer";
import AdminCompanyBillingContainer from "../../admin/company/containers/AdminCompanyBillingContainer";
import AdminCompanyContainer from "../../admin/company/containers/AdminCompanyContainer";
import AdminCompanyEditBillingContainer from "../../admin/company/containers/AdminCompanyEditBillingContainer";
import AdminCompanyEditContainer from "../../admin/company/containers/AdminCompanyEditContainer";
import AdminCompanyManagerContainer from "../../admin/company/containers/AdminCompanyManagerContainer";
import AdminCompanyProjectsContainer from "../../admin/company/containers/AdminCompanyProjectsContainer";
import AdminCreateProjectsContainer from "../../admin/new/projects/containers/AdminCreateProjectsContainer";
import AdminCreateUsersContainer from "../../admin/new/users/containers/AdminCreateUsersContainer";
import AdminDashboardContainer from "../../admin/dashboard/containers/AdminDashboardContainer";
import AdminMemberMatchesContainer from "../../admin/memberApprovedProfile/matches/containers/AdminMemberMatchesContainer";
import AdminMemberPitchesContainer from "../../admin/memberApprovedProfile/pitches/containers/AdminMemberPitchesContainer";
import AdminMemberProfileContainer from "../../admin/memberApprovedProfile/profile/containers/AdminMemberProfileContainer";
import AdminMemberStatementsOfWorkContainer from "../../admin/memberApprovedProfile/statementsOfWork/containers/AdminMemberStatementsOfWorkContainer";
import AdminPitchMessagesContainer from "../../admin/project/messages/containers/AdminPitchMessagesContainer";
import AdminProjectDetailContainer from "../../admin/project/detail/containers/AdminProjectDetailContainer";
import AdminProjectMatchesContainer from "../../admin/project/matches/containers/AdminProjectMatchesContainer";
import AdminProjectPitchesContainer from "../../admin/project/pitches/containers/AdminProjectPitchesContainer";
import AdminProjectPotentialMatchesContainer from "../../admin/project/potentialMatches/containers/AdminProjectPotentialMatchesContainer";
import AdminProjectReviewContainer from "../../admin/project/reviews/containers/AdminProjectReviewContainer";
import AdminProjectSowContainer from "../../admin/project/sow/containers/AdminProjectSowContainer";
import AdminReferralCodesContainer from "../../admin/new/referralCodes/containers/AdminReferralCodesContainer";
import AdminUsersContainer from "../../admin/users/containers/AdminUsersContainer";
import CompaniesContainer from "../../admin/companies/containers/CompaniesContainer";
import ConfirmationContainer from "../../admin/reference/containers/ConfirmationContainer";
import EditInvoiceContainer from "../../admin/invoice/edit/containers/EditInvoiceContainer";
import EditProjectDetailContainer from "../../admin/project/edit/containers/EditProjectDetailContainer";
import EditSowContainer from "../../admin/project/edit/containers/EditSowContainer";
import InvoicesContainer from "../../admin/invoices/containers/InvoicesContainer";
import MemberModerationContainer from "../../admin/memberModeration/containers/MemberModerationContainer";
import ProjectsContainer from "../../admin/projects/containers/ProjectsContainer";
import ReferenceContainer from "../../admin/reference/containers/ReferenceContainer";

import AdditionalMaterialsContainer from "../../candidate/profile/containers/AdditionalMaterialsContainer";
import CandidateCompleteProfile from "../../candidate/completeProfile/containers/CompleteProfileContainer";
import CandidateConfirmation from "../../candidate/confirmationScreen/containers/ConfirmationContainer";
import CandidateProfessionalSkills from "../../candidate/professionalSkills/containers/ProfessionalSkillsContainer";
import CandidateProjectContainer from "../../candidate/project/CandidateProjectContainer";
import CandidateReferences from "../../candidate/references/containers/ReferencesContainer";
import CandidateSignUpContainer from "../../candidate/signUp/containers/SignUpContainer";
import CandidateSignUpMarketingContainer from "../../candidate/signUpMarketing/containers/SignUpMarketingContainer";
import CandidateSignUpMarketing2Container from "../../candidate/signUpMarketing2/containers/SignUpMarketingContainer";
import CompletedContainer from "../../candidate/projects/completed/containers/CompletedContainer";
import EducationContainer from "../../candidate/profile/containers/EducationContainer";
import EmailContainer from "../../candidate/profile/containers/EmailContainer";
import EmployerReviewContainer from "../../candidate/employerReview/containers/EmployerReviewContainer";
import InvoiceContainer from "../../candidate/projects/invoice/containers/InvoiceContainer";
import InvoiceCreateContainer from "../../candidate/projects/invoice/containers/InvoiceCreateContainer";
import MatchesContainer from "../../candidate/projects/matches/containers/MatchesContainer";
import PitchesContainer from "../../candidate/projects/pitches/containers/PitchesContainer";
import PitchItContainer from "../../candidate/projects/matches/containers/PitchItContainer";
import ProfileContainer from "../../candidate/profile/containers/ProfileContainer";
import SettingsContainer from "../../candidate/settings/containers/SettingsContainer";
import SkillsAdminContainer from "../../candidate/profile/containers/SkillsAdminContainer";
import SkillsContainer from "../../candidate/profile/containers/SkillsContainer";
import StatementsOfWorkContainer from "../../candidate/projects/statementsOfWork/containers/StatementsOfWorkContainer";
import SummaryAdminContainer from "../../candidate/profile/containers/SummaryAdminContainer";
import SummaryContainer from "../../candidate/profile/containers/SummaryContainer";
import WorkHistoryContainer from "../../candidate/profile/containers/WorkHistoryContainer";

import CandidateReviewContainer from "../../employer/candidateReview/containers/CandidateReviewContainer";
import CompanyAffiliation from "../../employer/companyAffiliation/containers/CompanyAffiliationContainer";
import CompanyEmailPreferencesContainer from "../../employer/emailPreferences/containers/EmailPreferencesContainer";
import CompanyInvoicesContainer from "../../employer/invoice/containers/InvoiceContainer";
import CompanyPaymentAddCardContainer from "../../employer/payment/containers/CompanyPaymentAddCardContainer";
import CompanyPaymentContainer from "../../employer/payment/containers/CompanyPaymentContainer";
import CompanyPaymentInformationContainer from "../../employer/payment/containers/CompanyPaymentInformationContainer";
import CompanyProfileContainer from "../../employer/signUp/containers/CompanyProfileContainer";
import EditInformationContainer from "../../employer/editInformation/containers/EditInformationContainer";
import EmployerMessagesContainer from "../../employer/EmployerMessagesContainer/EmployerMessagesContainer";
import EmployerSignUpContainer from "../../employer/signUp/containers/SignUpContainer";
import Home from "../../employer/home/Home";
import MemberProfileContainer from "../../employer/memberProfile/container/memberProfileContainer";
import MemberProposalContainer from "../../employer/memberProposal/containers/MemberProposalContainer";
import ProjectBasicsContainer from "../../employer/project/containers/ProjectBasicsContainer";
import ProjectBudgetContainer from "../../employer/project/containers/ProjectBudgetContainer";
import ProjectCandidatesContainer from "../../employer/projectInformation/containers/ProjectCandidatesContainer";
import ProfileContainerCompany from "../../employer/profile/containers/ProfileContainer";
import ProjectDetailContainer from "../../employer/project/containers/ProjectDetailContainer";
import ProjectDetailFlowContainer from "../../employer/projectInformation/containers/ProjectDetailContainer";
import ProjectHiredContainer from "../../employer/projectInformation/containers/ProjectHiredContainer";
import ProjectIndexContainer from "../../employer/projectIndex/containers/ProjectIndexContainer";
import ProjectReviewContainer from "../../employer/project/containers/ProjectReviewContainer";
import ProjectSkillsContainer from "../../employer/project/containers/ProjectSkillsContainer";
import VerifyAccount from "../../employer/signUp/containers/VerifyAccountContainer";

import styles from "./Content.scss";

const Content = props => (
  <section className={classnames(styles.content, { hidden: props.loading })}>
    <Switch>
      <Route exact path="/" render={() => <Redirect to="/log-in" />} />
      <Route exact path="/log-in" component={CommonLogInContainer} />
      <Route
        exact
        path="/forgot-password"
        component={ForgotPasswordContainer}
      />
      <Route
        exact
        path="/forgot-password/confirmation-page"
        component={ConfirmationPage}
      />
      <Route exact path="/reset-password" component={ResetPasswordContainer} />

      <PrivateRoute
        role="employer"
        exact
        path="/account/email/preferences"
        component={CompanyEmailPreferencesContainer}
      />

      <Route
        exact
        path="/company/sign-up"
        component={EmployerSignUpContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/create-company/:companyName"
        component={CompanyProfileContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/account/settings"
        component={EditInformationContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/payment"
        component={CompanyPaymentContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/payment/information"
        component={CompanyPaymentInformationContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/payment/add"
        component={CompanyPaymentAddCardContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/companyAffiliation"
        component={CompanyAffiliation}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/home"
        component={Home}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/verify-account"
        component={VerifyAccount}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/projects"
        component={ProjectIndexContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/invoices"
        component={CompanyInvoicesContainer}
      />

      <PrivateRoute
        role={["admin", "employer"]}
        exact
        path="/company/project/create"
        component={ProjectBasicsContainer}
      />
      <PrivateRoute
        role={["admin", "employer"]}
        exact
        path="/company/project/id/:projectId/basics"
        component={ProjectBasicsContainer}
      />
      <PrivateRoute
        role={["admin", "employer"]}
        exact
        path="/company/project/id/:projectId/details"
        component={ProjectDetailContainer}
      />
      <PrivateRoute
        role={["admin", "employer"]}
        exact
        path="/company/project/id/:projectId/skills"
        component={ProjectSkillsContainer}
      />
      <PrivateRoute
        role={["admin", "employer"]}
        exact
        path="/company/project/id/:projectId/budget"
        component={ProjectBudgetContainer}
      />
      <PrivateRoute
        role={["admin", "employer"]}
        exact
        path="/company/project/id/:projectId/review"
        component={ProjectReviewContainer}
      />

      <PrivateRoute
        role="employer"
        exact
        path="/company/project/:projectId"
        component={ProjectDetailFlowContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/project/:projectId/candidates"
        component={ProjectCandidatesContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/project/:projectId/hired"
        component={ProjectHiredContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/pitch/:pitchId/member/:memberId/project/:projectId/memberProfile"
        component={MemberProfileContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/pitch/:pitchId/member/:memberId/project/:projectId/sow"
        component={MemberProposalContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/pitch/:pitchId/member/:memberId/project/:projectId/sow/edit"
        component={MemberProposalContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/pitch/:pitchId/member/:memberId/project/:projectId/messages"
        component={EmployerMessagesContainer}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/:companyId"
        component={ProfileContainerCompany}
      />
      <PrivateRoute
        role="employer"
        exact
        path="/company/review/:projectId/member/:memberId"
        component={CandidateReviewContainer}
      />

      <Route
        exact
        path="/member/sign-up"
        component={CandidateSignUpContainer}
      />
      <Route
        exact
        path="/member/sign-up-marketing"
        component={CandidateSignUpMarketingContainer}
      />
      <Route
        exact
        path="/member/sign-up-marketing-2"
        component={CandidateSignUpMarketing2Container}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/complete-profile"
        component={CandidateCompleteProfile}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/skills"
        component={CandidateProfessionalSkills}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/endorsements"
        component={CandidateReferences}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/confirmation"
        component={CandidateConfirmation}
      />

      <PrivateRoute
        role="member"
        exact
        path="/member/projects/matches"
        component={MatchesContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/projects/matches/pitch-it/:matchId/"
        component={PitchItContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/projects/pitches"
        component={PitchesContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/projects/sows"
        component={StatementsOfWorkContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/projects/completed"
        component={CompletedContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/projects/invoices"
        component={InvoiceContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/invoice/create"
        component={InvoiceCreateContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/account/settings"
        component={SettingsContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/profile"
        component={ProfileContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/profile/education"
        component={EducationContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/profile/work-history"
        component={WorkHistoryContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/profile/additional-materials"
        component={AdditionalMaterialsContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/profile/summary"
        component={SummaryContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/profile/skills"
        component={SkillsContainer}
      />

      <PrivateRoute
        role="member"
        exact
        path="/member/project/:projectId/detail"
        component={CandidateProjectContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/project/:projectId/sow"
        component={CandidateProjectContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/project/:projectId/sow/edit"
        component={CandidateProjectContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/project/:projectId/messages"
        component={CandidateProjectContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/review/:projectId"
        component={EmployerReviewContainer}
      />
      <PrivateRoute
        role="member"
        exact
        path="/member/company/:companyId"
        component={ProfileContainerCompany}
      />

      <PrivateRoute
        role="admin"
        exact
        path="/admin/dashboard"
        component={AdminDashboardContainer}
      />
      <Route exact path="/admin/reference" component={ReferenceContainer} />
      <Route
        exact
        path="/admin/reference/confirmation"
        component={ConfirmationContainer}
      />

      <PrivateRoute
        role="admin"
        exact
        path="/admin/projects"
        component={ProjectsContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/project/:projectId/detail"
        component={AdminProjectDetailContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/project/:projectId/matches"
        component={AdminProjectMatchesContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/project/:projectId/pitches"
        component={AdminProjectPitchesContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/project/:projectId/reviews"
        component={AdminProjectReviewContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/project/:projectId/sow"
        component={AdminProjectSowContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/project/:projectId/sow/:sowId/edit"
        component={EditSowContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/project/:projectId/potential-matches"
        component={AdminProjectPotentialMatchesContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/project/:projectId/edit"
        component={EditProjectDetailContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/project/:projectId/pitch/:pitchId/messages"
        component={AdminPitchMessagesContainer}
      />

      <PrivateRoute
        role="admin"
        exact
        path="/admin/companies"
        component={CompaniesContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/companies/invoices"
        component={InvoicesContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/company/:companyId"
        component={AdminCompanyContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/company/:companyId/edit"
        component={AdminCompanyEditContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/company/:companyId/edit/billing"
        component={AdminCompanyEditBillingContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/company/:companyId/projects"
        component={AdminCompanyProjectsContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/company/:companyId/billing"
        component={AdminCompanyBillingContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/company/:companyId/billing/add"
        component={AdminCompanyBillingAddContainer}
      />

      <PrivateRoute
        role="admin"
        exact
        path="/admin/new"
        component={AdminCreateProjectsContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/new/projects"
        component={AdminCreateProjectsContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/new/users"
        component={AdminCreateUsersContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/new/referral-codes"
        component={AdminReferralCodesContainer}
      />

      <PrivateRoute
        role="admin"
        exact
        path="/admin/users"
        component={AdminUsersContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/company/manager/:userId"
        component={AdminCompanyManagerContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/:memberId/moderation"
        component={MemberModerationContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/:memberId/profile/email"
        component={EmailContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/approved/:memberId/profile/email"
        component={EmailContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/:memberId/profile/skills"
        component={SkillsAdminContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/approved/:memberId/profile/skills"
        component={SkillsAdminContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/:memberId/profile/summary"
        component={SummaryAdminContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/approved/:memberId/profile/summary"
        component={SummaryAdminContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/:memberId/profile/education"
        component={EducationContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/approved/:memberId/profile/education"
        component={EducationContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/:memberId/profile/work-history"
        component={WorkHistoryContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/approved/:memberId/profile/work-history"
        component={WorkHistoryContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/:memberId/profile/additional-materials"
        component={AdditionalMaterialsContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/approved/:memberId/profile/additional-materials"
        component={AdditionalMaterialsContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/approved/:memberId/profile"
        component={AdminMemberProfileContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/approved/:memberId/matches"
        component={AdminMemberMatchesContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/approved/:memberId/pitches"
        component={AdminMemberPitchesContainer}
      />
      <PrivateRoute
        role="admin"
        exact
        path="/admin/member/approved/:memberId/sows"
        component={AdminMemberStatementsOfWorkContainer}
      />

      <PrivateRoute
        role="admin"
        exact
        path="/admin/invoice/:invoiceId/edit"
        component={EditInvoiceContainer}
      />
    </Switch>
  </section>
);

export default Content;



// WEBPACK FOOTER //
// ./src/routes/common/content/Content.js